import { AdPortfolioEntity } from 'sl-api-connector/types';

import types from './types';

const receiveAdPortfolios = (adPortfolios: AdPortfolioEntity[]) => ({
  type: types.RECEIVE_ADPORTFOLIOS,
  adPortfolios,
  receivedAt: Date.now()
});

const clearAdPortfolios = () => ({ type: types.CLEAR_ADPORTFOLIOS });

const receiveAdPortfoliosData = (adPortfoliosData?: {
  mtdSpend: {
    [key: string]: any;
  };
  projectedSpend: {
    [key: string]: any;
  };
}) =>
  ({
    type: types.RECEIVE_ADPORTFOLIOS_DATA,
    adPortfoliosData,
    receivedAt: Date.now()
  } as any);

const clearAdPortfoliosData = () => ({ type: types.CLEAR_ADPORTFOLIOS_DATA });

export default {
  clearAdPortfolios,
  receiveAdPortfolios,
  receiveAdPortfoliosData,
  clearAdPortfoliosData
};
